import { Flex, FlexProps, Box, Image } from '@chakra-ui/core'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { images, theme } from '../theme'
import { useAuthContext } from '../context/AuthProvider'
import { Notifications } from '../features'
import { useAppContext } from '../context/AppProvider'
import SideBarButton from '../components/SideBar/SideBarButton'
import { Breadcrumbs } from '../components'

const MIN_WIDTH = 320
type PageWrapProps = FlexProps & {
  title: string
}

const PageWrap: React.FC<PageWrapProps> = ({ children, title, ...rest }) => {
  const { isAuthenticated } = useAuthContext()
  const { drawerOpen, toggleDrawer, isTabletOrMobile } = useAppContext()

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Flex {...rest}>
        {isAuthenticated && (
          <>
            <Flex align="center" justify="space-between" mb={4} w="100%" minW={MIN_WIDTH}>
              <Flex align="center">
                {isTabletOrMobile && (
                  <SideBarButton
                    color={theme.colors.text[50]}
                    open={drawerOpen}
                    onClick={toggleDrawer}
                  />
                )}
                {!drawerOpen && (
                  <Image
                    src={images.logo}
                    alt="Logo"
                    w={150}
                    mr={4}
                    objectFit="contain"
                    fallbackSrc="https://via.placeholder.com/50"
                  />
                )}
                {!isTabletOrMobile && <Breadcrumbs />}
              </Flex>
              <Notifications />
            </Flex>
          </>
        )}
        <Box w="100%" minW={MIN_WIDTH} px={3}>
          {children}
        </Box>
      </Flex>
    </>
  )
}

PageWrap.defaultProps = {
  p: 4,
  flex: 1,
  bg: '#f9fbfc',
  height: '100%',
  flexDir: 'column',
  minHeight: '100vh',
  align: 'flex-start',
  justify: 'flex-start'
}

export default PageWrap
